import { ECardType } from '__generated__/globalTypes';
import { FacebookCard } from 'components/detail/view/DetailCards/FacebookCard';
import { GIFCard } from 'components/detail/view/DetailCards/GIFCard';
import { ImageCard } from 'components/detail/view/DetailCards/ImageCard';
import { InstagramCard } from 'components/detail/view/DetailCards/InstagramCard';
import { LinkCard } from 'components/detail/view/DetailCards/LinkCard';
import { LinkedDetailsCard } from 'components/detail/view/DetailCards/LinkedDetailsCard';
import { ProgramCard } from 'components/detail/view/DetailCards/ProgramCard';
import { TextCard } from 'components/detail/view/DetailCards/TextCard';
import { TwitterCard } from 'components/detail/view/DetailCards/TwitterCard';
import { YoutubeCard } from 'components/detail/view/DetailCards/YoutubeCard';
import { Temp_ItaliaTourCard } from 'components/detail/view/Temp_ItaliaTourCard';
import {
    DetailQuery_moment_cards,
    DetailQuery_moment_cards_FacebookCard,
    DetailQuery_moment_cards_GifCard,
    DetailQuery_moment_cards_ImageCard,
    DetailQuery_moment_cards_InstagramCard,
    DetailQuery_moment_cards_LinkCard,
    DetailQuery_moment_cards_LinkedStoriesCard,
    DetailQuery_moment_cards_TextCard,
    DetailQuery_moment_cards_TwitterCard,
    DetailQuery_moment_cards_VideoCard
} from 'graphql/query/__generated__/DetailQuery';
import styled from 'styled-components/macro';

export interface SpeakerData {
    storyId: string;
    imageUrl: string;
    name: string;
    description: string;
}

interface Props {
    cards: DetailQuery_moment_cards[];
    programIds?: string[];
    noMarginBottom?: boolean;
    className?: string;
    children?: React.ReactNode;
}

export const DetailCards = (props: Props): JSX.Element => {
    return (
        <S_DetailCards className={props.className} $noMarginBottom={props.noMarginBottom}>
            {props.cards.map((card) => {
                return (
                    <S_Card key={card.cardId}>
                        {card.type === ECardType.FACEBOOK && (
                            <FacebookCard
                                card={card as unknown as DetailQuery_moment_cards_FacebookCard}
                            />
                        )}
                        {card.type === ECardType.GIF && (
                            <GIFCard card={card as unknown as DetailQuery_moment_cards_GifCard} />
                        )}
                        {card.type === ECardType.IMAGE && (
                            <ImageCard
                                card={card as unknown as DetailQuery_moment_cards_ImageCard}
                            />
                        )}
                        {card.type === ECardType.INSTAGRAM && (
                            <InstagramCard
                                card={card as unknown as DetailQuery_moment_cards_InstagramCard}
                            />
                        )}
                        {card.type === ECardType.LINK && (
                            <LinkCard card={card as unknown as DetailQuery_moment_cards_LinkCard} />
                        )}
                        {card.type === ECardType.TEXT && (
                            <TextCard card={card as unknown as DetailQuery_moment_cards_TextCard} />
                        )}
                        {card.type === ECardType.TWITTER && (
                            <TwitterCard
                                card={card as unknown as DetailQuery_moment_cards_TwitterCard}
                            />
                        )}
                        {card.type === ECardType.VIDEO && (
                            <YoutubeCard
                                card={card as unknown as DetailQuery_moment_cards_VideoCard}
                            />
                        )}
                        {card.type === ECardType.LINKEDSTORIES && (
                            <LinkedDetailsCard
                                card={card as unknown as DetailQuery_moment_cards_LinkedStoriesCard}
                            />
                        )}
                        {/* For Italia-tours demo */}
                        {card.cardId === '0.07737762631266798' && (
                            <Temp_ItaliaTourCard couponCode="ITALIA10" />
                        )}
                        {card.cardId === '0.38322997315276597' && (
                            <Temp_ItaliaTourCard couponCode="FREEORSA" />
                        )}
                    </S_Card>
                );
            })}
            {props.children}
            {props.programIds?.length && <ProgramCard programIds={props.programIds} />}
        </S_DetailCards>
    );
};

const S_DetailCards = styled.div<{ $noMarginBottom: boolean }>`
    background-color: #f6f9ff;
    display: flex;
    flex-direction: column;
    padding: 20px 20px 0 20px;
    margin-bottom: ${(props) => (props.$noMarginBottom ? '0px' : '120px')};
    @media only screen and (min-width: 1260px) {
        margin-bottom: 0px;
        padding: 20px 35px 150px 35px;
    }
`;

const S_Card = styled.div`
    margin: 20px 0 20px 0;
`;
